import { GridColDef } from '@mui/x-data-grid-premium'

export const baseColumnConfig = {
  display: 'flex',
  sortable: true,
  groupable: true,
  hideable: true,
  editable: false,
  width: 200,
} satisfies Partial<GridColDef>
